import * as Dialog from "@radix-ui/react-dialog";
import { ReactComponent as CloseIcon } from "assets/img/icons/header/close.svg";
import { CalendarFriendlyEvent } from "./types";
import { EventDetailsBody } from "./EventDetailsBody";

type EventDetailsModalProps = {
    isOpen: boolean;
    onClose: (open: boolean) => void;
    event: CalendarFriendlyEvent;
};

export function EventDetailsModal({ isOpen, onClose, event }: EventDetailsModalProps) {
    return (
        <Dialog.Root open={isOpen} onOpenChange={onClose}>
            <Dialog.Overlay className="fixed inset-0 z-50 bg-[#424242]/75" />
            <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[460px] max-w-[90%] -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white p-6 shadow-none">
                <div className="mb-2 flex items-center justify-between">
                    <h2 className="font-sans text-[24px] font-bold leading-[100%] text-[#424242]">
                        Event
                    </h2>
                    <Dialog.Close>
                        <CloseIcon className="-mt-2 h-[30px] w-[30px]" />
                    </Dialog.Close>
                </div>

                <hr className="-mx-[24px] my-4 border-0 border-b border-[#c8c8c8] shadow-none" />

                <EventDetailsBody event={event} />
            </Dialog.Content>
        </Dialog.Root>
    );
}
